module.exports = __webpack_public_path__ + "static/media/290826.c67eaaaa.png";